var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 133,
    viewBox: "0 0 190 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M144.86 42.6273C144.566 42.6273 144.212 42.5683 143.917 42.5683C142.385 42.5683 140.853 42.5683 139.32 42.7453C133.84 18.6773 112.27 0.567383 86.4565 0.567383C56.5179 0.567383 32.2959 24.6943 32.2959 54.4843C32.2959 56.313 32.4138 58.0827 32.5906 59.8524C14.321 61.4452 0 77.6085 0 96.1903C0 115.893 15.7944 133 35.5373 133H144.86C169.554 133 189.532 112.531 189.532 87.9907C189.532 63.4508 169.554 42.6273 144.86 42.6273Z",
    fill: "#A797D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud1.c8e8388363c525ea8930644655fd060f.svg";
export { ForwardRef as ReactComponent };